import { instance } from '../../config/intercepter';

export const getCarIconsFn =  async () => {
  const response = await instance.get(`api/car-icons`);
  return response.data;
};

export const postCarIconsFn =  async (carIcons) => {
  // For the love of God... this needs an explanation!
  // this api works by posting to it a list [] of ids.
  // The BE chooses the most significant one and returns only that one's message and meaning.
  // However, the UI was never designed to work like this. 
  // What the Product needs and wants, is simply clicking on one icon and seeing its meaning.
  // May the Code God light your path forward. 
  const response = await instance.post(`api/car-icons`, { icons: carIcons });
  return response.data;
};